import React from 'react';

const JobScheduleTableHeader = ({ filters, showActionColumn }) => {
  const isControlPanelView = Boolean(filters.controlPanelView);
  const isNorthPrairieView = Boolean(filters.northPrairieView);
  const showPumpsSection = filters.departments.pumps && !isControlPanelView;
  const showNorthPrairieSection = filters.departments.northPrairie && !isControlPanelView;
  const showControlPanelSection = filters.departments.controlPanel && !isNorthPrairieView;
  const showTestSection = filters.departments.test && !isNorthPrairieView;
  const hideCurrentPlanShipDate = Boolean(filters.hideCurrentPlanShipDate);
  const engineeringColumnSpan = isControlPanelView
    ? (filters.dueDatesOnly ? 1 : 4)
    : isNorthPrairieView
    ? (filters.dueDatesOnly ? 1 : 3)
    : (filters.dueDatesOnly ? 2 : 7);
  const fabricationColumnSpan = isControlPanelView
    ? (filters.dueDatesOnly ? 1 : 3)
    : (filters.dueDatesOnly ? 3 : 6);
  const assemblyColumnSpan = isNorthPrairieView
    ? (filters.dueDatesOnly ? 1 : 2)
    : (filters.dueDatesOnly ? 1 : 3);
  const shippingColumnSpan = isNorthPrairieView
    ? (filters.dueDatesOnly ? 2 : 4) - (hideCurrentPlanShipDate ? 1 : 0)
    : (filters.dueDatesOnly ? 4 : 6) - (hideCurrentPlanShipDate ? 1 : 0);

  // Software view shows only specific columns
  if (filters.softwareView) {
    return (
      <thead>
        <tr>
          {showActionColumn && (
            <th className="action-column header-cell">
              <i className="bi bi-pencil"></i>
            </th>
          )}
          {filters.compactInlineIdentity && (
            <>
              <th className="compact-inline-project-column header-cell">Project</th>
              <th className="compact-inline-model-column header-cell">Model</th>
            </>
          )}
          <th className="row-number-column header-cell">#</th>
          <th className="job-number-column header-cell" data-column-id="jobNumber">Job Number</th>
          <th className="sticky-column job-name-column header-cell" data-column-id="projectName">Job Name</th>
          <th className="model-number-column header-cell" data-column-id="modelNumber">Model Number</th>
          <th className="header-cell" data-column-id="softwareType">Software Type</th>
          <th className="header-cell" data-column-id="softwareDue">Software Due</th>
          <th className="header-cell" data-column-id="softwareDone">Software Done</th>
        </tr>
      </thead>
    );
  }

  // Regular view (existing code)
  return (
    <thead>
      <tr>
        {showActionColumn && (
          <th rowSpan={2} className="action-column header-cell">
            <i className="bi bi-pencil"></i>
          </th>
        )}
        {filters.compactInlineIdentity && (
          <>
            <th rowSpan={2} className="compact-inline-project-column header-cell">Project</th>
            <th rowSpan={2} className="compact-inline-model-column header-cell">Model</th>
          </>
        )}
        <th rowSpan={2} className="row-number-column header-cell">#</th>
        <th rowSpan={2} className="job-number-column header-cell" data-column-id="jobNumber">Job Number</th>
        <th rowSpan={2} className="model-number-column header-cell" data-column-id="modelNumber">Model Number</th>
        <th rowSpan={2} className="sticky-column job-name-column header-cell" data-column-id="projectName">Job Name</th>
        {!filters.dueDatesOnly && <th rowSpan={2} className="order-received-column header-cell" data-column-id="orderDate">Order Date</th>}
        {!filters.dueDatesOnly && <th rowSpan={2} className="production-release-column header-cell" data-column-id="productionRelease">Release To Scheduling</th>}
        {!filters.dueDatesOnly && <th rowSpan={2} className="release-meeting-date-column header-cell" data-column-id="releaseMeetingDate">Release Meeting Date</th>}
        {filters.departments.engineering && (
          filters.dueDatesOnly ? 
          <th colSpan={engineeringColumnSpan} className="department-header">Engineering Due</th> :
          <th colSpan={engineeringColumnSpan} className="department-header">Engineering</th>
        )}
        {filters.departments.fabrication && (
          filters.dueDatesOnly ? 
          <th colSpan={fabricationColumnSpan} className="department-header">Fabrication Due</th> :
          <th colSpan={fabricationColumnSpan} className="department-header">Fabrication</th>
        )}
        {showControlPanelSection && (
          filters.dueDatesOnly ? 
          <th colSpan={2} className="department-header">Control Panel Due</th> :
          <th colSpan={6} className="department-header">Control Panel</th>
        )}
        {showPumpsSection && (
          filters.dueDatesOnly ? 
          <th colSpan={2} className="department-header">Pumps Due</th> :
          <th colSpan={5} className="department-header">Pumps</th>
        )}
        {filters.departments.assembly && (
          filters.dueDatesOnly ? 
          <th colSpan={assemblyColumnSpan} className="department-header">Assembly Due</th> :
          <th colSpan={assemblyColumnSpan} className="department-header">Assembly</th>
        )}
        {showTestSection && (
          filters.dueDatesOnly ? 
          <th colSpan={1} className="department-header">Test Due</th> :
          <th colSpan={3} className="department-header">Test</th>
        )}
        {showNorthPrairieSection && (
          filters.dueDatesOnly ? 
          <th colSpan={filters.departments.fabrication ? 4 : 5} className="department-header">North Prairie Due</th> :
          <th colSpan={filters.departments.fabrication ? 8 : 10} className="department-header">North Prairie</th>
        )}
        {filters.departments.shipping && (
          filters.dueDatesOnly ? 
          <th colSpan={shippingColumnSpan} className="department-header">Shipping</th> :
          <th colSpan={shippingColumnSpan} className="department-header">Shipping</th>
        )}
        {filters.departments.portalDetails && <th colSpan={2} className="department-header">Portal Details</th>}
        <th rowSpan={2} className="notes-column header-cell" data-column-id="notes">Notes</th>
        {!isControlPanelView && (
          <>
            <th rowSpan={2} className="payment-terms-column header-cell" data-column-id="paymentTerms">Payment Terms</th>
            {!filters.dueDatesOnly && <th rowSpan={2} className="dollar-value-column header-cell" data-column-id="dollarValue">Dollar Value</th>}
            <th rowSpan={2} className="header-cell" data-column-id="leadTime">Lead Time</th>
          </>
        )}
      </tr>
      <tr>
        {filters.departments.engineering && (
          filters.dueDatesOnly ? (
            <>
              {!isControlPanelView && (
                <th className="header-cell" data-column-id="mechanicalDue">Mechanical Due</th>
              )}
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="electricalDue">Electrical Due</th>
              )}
            </>
          ) : (
            <>
              {!isControlPanelView && (
                <th className="header-cell" data-column-id="mechanicalEngineer">Mechanical</th>
              )}
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="electricalEngineer">Electrical</th>
              )}
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="controlsEngineer">Controls</th>
              )}
              {!isControlPanelView && (
                <>
                  <th className="header-cell" data-column-id="mechanicalDue">Mech Due</th>
                  <th className="header-cell" data-column-id="mechanicalDone">Mech Done</th>
                </>
              )}
              {!isNorthPrairieView && (
                <>
                  <th className="header-cell" data-column-id="electricalDue">Elec Due</th>
                  <th className="header-cell" data-column-id="electricalDone">Elec Done</th>
                </>
              )}
            </>
          )
        )}
        {filters.departments.fabrication && (
          filters.dueDatesOnly ? (
            <>
              {!isControlPanelView && (
                <>
                  <th className="header-cell" data-column-id="npPipeFabDue">NP Pipe Fab Due</th>
                  <th className="header-cell" data-column-id="fusionBondRequired">Fusion Bond Req</th>
                </>
              )}
              <th className="header-cell" data-column-id="fabDue">Fab Due</th>
            </>
          ) : (
            <>
              {!isControlPanelView && (
                <>
                  <th className="header-cell" data-column-id="npPipeFabDue">NP Pipe Fab Due</th>
                  <th className="header-cell" data-column-id="npPipeFabDone">NP Pipe Fab Done</th>
                  <th className="header-cell" data-column-id="fusionBondRequired">Fusion Bond Req</th>
                </>
              )}
              <th className="header-cell" data-column-id="fabDue">Fab Due</th>
              <th className="header-cell" data-column-id="fabDone">Fab Done</th>
              <th className="header-cell" data-column-id="fabExpectedCompletion">Fab Exp Comp</th>
            </>
          )
        )}
        {showControlPanelSection && (
          filters.dueDatesOnly ? (
            <>
              <th className="header-cell" data-column-id="softwareDue">Software Due</th>
              <th className="header-cell" data-column-id="controlPanelDue">Control Panel Due</th>
            </>
          ) : (
            <>
              <th className="header-cell" data-column-id="softwareDue">Software Due</th>
              <th className="header-cell" data-column-id="softwareType">Software Type</th>
              <th className="header-cell" data-column-id="softwareDone">Software Done</th>
              <th className="header-cell" data-column-id="controlPanelDue">CP Due</th>
              <th className="header-cell" data-column-id="controlPanelDone">CP Done</th>
              <th className="header-cell" data-column-id="controlPanelExpectedCompletion">CP Exp Comp</th>
            </>
          )
        )}
        {showPumpsSection && (
          filters.dueDatesOnly ? (
            <>
              <th className="header-cell" data-column-id="hcPumpsDue">HC Pumps Due</th>
              <th className="header-cell" data-column-id="vtPumpsDue">VT Pumps Due</th>
            </>
          ) : (
            <>
              <th className="header-cell" data-column-id="hcPumpsDue">HC Pumps Due</th>
              <th className="header-cell" data-column-id="hcPumpsDone">HC Pumps Done</th>
              <th className="header-cell" data-column-id="vtPumpsDue">VT Pumps Due</th>
              <th className="header-cell" data-column-id="pumpsDone">VT Pumps Done</th>
              <th className="header-cell" data-column-id="pumpExpectedCompletion">Pump Exp Comp</th>
            </>
          )
        )}
        {filters.departments.assembly && (
          filters.dueDatesOnly ? (
            <th className="header-cell" data-column-id="assemblyDue">Assembly Due</th>
          ) : (
            <>
              <th className="header-cell" data-column-id="assemblyDue">Asm Due</th>
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="assemblyDone">Asm Done</th>
              )}
              <th className="header-cell" data-column-id="assemblyExpectedCompletion">Asm Exp Comp</th>
            </>
          )
        )}
        {showTestSection && (
          filters.dueDatesOnly ? (
            <th className="header-cell" data-column-id="testDue">Test Due</th>
          ) : (
            <>
              <th className="header-cell" data-column-id="testDue">Test Due</th>
              <th className="header-cell" data-column-id="testDone">Test Done</th>
              <th className="header-cell" data-column-id="testExpectedCompletion">Test Exp Comp</th>
            </>
          )
        )}
        {showNorthPrairieSection && (
          filters.dueDatesOnly ? (
            <>
              {!filters.departments.fabrication && (
                <th className="header-cell" data-column-id="npPipeFabDue">NP Pipe Fab Due</th>
              )}
              <th className="header-cell" data-column-id="npCsmDue">NP CSM Due</th>
              <th className="header-cell" data-column-id="npSuctionLineDue">NP Suction Line Due</th>
              <th className="header-cell" data-column-id="npInducerTubeDue">NP Inducer Tube Due</th>
              <th className="header-cell" data-column-id="npBmxDue">NP BMX Due</th>
            </>
          ) : (
            <>
              {!filters.departments.fabrication && (
                <>
                  <th className="header-cell" data-column-id="npPipeFabDue">NP Pipe Fab Due</th>
                  <th className="header-cell" data-column-id="npPipeFabDone">NP Pipe Fab Done</th>
                </>
              )}
              <th className="header-cell" data-column-id="npCsmDue">CSM Due</th>
              <th className="header-cell" data-column-id="npCsmDone">CSM Done</th>
              <th className="header-cell" data-column-id="npSuctionLineDue">Suction Line Due</th>
              <th className="header-cell" data-column-id="npSuctionLineDone">Suction Line Done</th>
              <th className="header-cell" data-column-id="npInducerTubeDue">Inducer Tube Due</th>
              <th className="header-cell" data-column-id="npInducerTubeDone">Inducer Tube Done</th>
              <th className="header-cell" data-column-id="npBmxDue">BMX Due</th>
              <th className="header-cell" data-column-id="npBmxDone">BMX Done</th>
            </>
          )
        )}
        {filters.departments.shipping && (
          filters.dueDatesOnly ? (
            <>
              <th className="header-cell" data-column-id="packDue">Pack Due</th>
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="transportType">Transport Type</th>
              )}
              {!hideCurrentPlanShipDate && (
                <th className="header-cell" data-column-id="currentPlanShipDate">Current Plan Ship Date</th>
              )}
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="scheduledArrivalDate">Scheduled Arrival Date</th>
              )}
            </>
          ) : (
            <>
              <th className="header-cell" data-column-id="packDue">Pack Due</th>
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="transportType">Transport Type</th>
              )}
              <th className="header-cell" data-column-id="originalScheduledShipDate">Orig Schd Ship</th>
              {!hideCurrentPlanShipDate && (
                <th className="header-cell" data-column-id="currentPlanShipDate">Current Plan Ship</th>
              )}
              <th className="header-cell" data-column-id="actualShipDate">Actual Ship</th>
              {!isNorthPrairieView && (
                <th className="header-cell" data-column-id="scheduledArrivalDate">Scheduled Arrival</th>
              )}
            </>
          )
        )}
        {filters.departments.portalDetails && (
          <>
            <th className="header-cell" data-column-id="salesRep">Sales Rep</th>
            <th className="header-cell" data-column-id="jobLocation">Job Location</th>
          </>
        )}
      </tr>
    </thead>
  );
};

export default JobScheduleTableHeader;
